import { initialState } from "./state";

export default {
  setPeiAdmendment(state, data) {
    state.sections = data;
  },
  setPeiAdmendmentService(state, data) {
    state.sectionsServices = data;
  },
  setCorrelationParameter(state, data) {
    state.correlationParameter = data;
  }
};
